/*
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-29 16:25:23
 * @Description: 这里是公共方法（纯函数 pure function）
 */


// 将 1e-8 转为 0.00000001（强制处理）
// 将 1 转为 1.00 （按须处理）
// 将 1.23456 转为 1.23 （按须处理）
export function transferToNumber(
    inputNumber: number,
    tailMin?: number, // 传2，表示最少保留2位小数
    tailMax?: number, // 传8，表示最多保留8位小数
): string {
    inputNumber = Number(inputNumber);
    let sResult = ''; // ◀最终返回的结果
    const strValue = String(inputNumber);
    // 👇 场景01：非科学计数法的常规形态数字
    if (strValue.match(/e/i) == null){
        sResult = strValue;
    // 👇 场景02：“科学计数法” 形态的数字
    }else if (tailMax){
        sResult = inputNumber.toFixed(tailMax);
    }else{
        const eformat = inputNumber.toExponential(); // 转换为标准的科学计数法形式（字符串）
        const tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/); // 分离出小数值和指数值
        const partA = (tmpArray[1] || '').length;
        const partB = Number(tmpArray[2]);
        const tailLong = Math.max(0, partA - partB);
        sResult = inputNumber.toFixed(tailLong);
    }
    // ▼没有小数点
    if (sResult.includes('.') == false){
        if (tailMin){
            sResult += '.' + '0'.repeat(tailMin); 
        }
        return sResult; // 返回，转换完成
    }
    // ▼处理小数点右侧长度
    sResult = trimRightZero(sResult);
    let rightPart = sResult.split('.')[1] || '';
    if (rightPart.length > tailMax){
        const toDel = rightPart.length - tailMax;
        sResult = sResult.slice(0, toDel * -1);
    }
    // ▼一定放在最后判断
    if (rightPart.length < tailMin){
        const iLong = tailMin - rightPart.length;
        sResult += sResult.includes('.') ? '' : '.';
        sResult += '0'.repeat(iLong);
    }
    return sResult;
}

